import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import './styles/Auth.css';
import './styles/Dashboard.css';
import './styles/modal.css';
import './styles/toast.css';
import './styles/features.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
